import type { FC } from 'react';
import { HelpCaption } from '../capations/help-caption';
import { SupportTitle } from '../capations/support-title';
import { WistiaPlayer } from '../player/wistia-player';

export const AuctionHelpCenterContent: FC = () => {
  const playerHeight = '533px';
  const mediaId = 'wex955xtyx';

  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>Help with Auction Page</HelpCaption>
      <WistiaPlayer mediaId={mediaId} height={playerHeight} />
    </div>
  );
};
